module.exports = __webpack_public_path__ + "static/media/red.ef013c0c.png";